import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRightArrowLong = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 17,
	fill: "none",
	"xmlns:v": "https://vecta.io/nano",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#A)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M15.413 7.107L12.833 4.5c-.062-.062-.136-.112-.217-.146s-.168-.051-.256-.051-.175.017-.256.051-.155.083-.217.146c-.124.125-.194.294-.194.47s.07.345.194.47l2.373 2.393H.667c-.177 0-.346.07-.471.195S0 8.323 0 8.5s.07.346.195.471.295.195.471.195H14.3l-2.413 2.407a.67.67 0 0 0-.197.473c0 .088.017.175.051.256a.67.67 0 0 0 .363.363.67.67 0 0 0 .513 0 .67.67 0 0 0 .217-.146l2.58-2.587a2 2 0 0 0 0-2.827z",
			fill: "#1cb954"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "A",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			transform: "translate(0 .5)",
			d: "M0 0h16v16H0z"
		})
	}) })]
});
export default SvgRightArrowLong;
